import React, { Fragment } from 'react';
import CardMedia from '@material-ui/core/CardMedia';

const Picture = ({ images = '', defaultImage = '', sizes = '', className = '' }) => {
  const srcSet = Array.isArray(images) ? images.map((e) => `${e.url} ${e.key}`) : '';
  return (
    <>
      {srcSet.length > 0 && (
        <CardMedia
          component="img"
          className={className}
          srcSet={srcSet}
          sizes={sizes}
          src={defaultImage}
        />
      )}
    </>
  );
};
export default Picture;
